import React, { Component } from "react";
import { Layout } from "antd";
import "./ContentRoutes.css";
import { Route } from "react-router-dom";

import LoginPage from '../pages/LoginPage';
import HomePage from '../pages/HomePage';
import ConfiguracoesPage from '../pages/ConfiguracoesPage';
import AjudasPage from '../pages/AjudasPage';
import SobrePage from '../pages/SobrePage';

import AgendaPage from '../pages/AgendaPage';
import TipoAgendasPage from '../pages/TipoAgendasPage';

import VendasPage from "../pages/VendasPage";
import PedidosPage from "../pages/PedidosPage";
import VendaBalcaoPage from "../pages/VendaBalcaoPage";
import CondicionaisPage from "../pages/CondicionaisPage";
import InventarioPage from "../pages/InventarioPage";
import PedidosProdutosPage from "../pages/PedidosProdutosPage";
import EstornoVendasPage from "../pages/EstornoVendasPage";

import ContratosPage from "../pages/ContratosPage";
import ContratosFaturamentoPage from "../pages/ContratosFaturamentoPage";

import ComprasPage from "../pages/ComprasPage";
import ComprasProdutosPage from "../pages/ComprasProdutosPage";

import GruposPessoasPage from "../pages/GruposPessoasPage";
import PessoasPage from "../pages/PessoasPage";
import ProdutosPage from "../pages/ProdutosPage";
import GruposProdutosPage from "../pages/GruposProdutosPage";
import MarcasPage from "../pages/MarcasPage";
import MedidasPage from "../pages/MedidasPage";
import ProdutoTamanhoPage from "../pages/ProdutoTamanhoPage";
import ProdutoCorPage from "../pages/ProdutoCorPage";

import OrcamentosPage from "../pages/OrcamentosPage";
import OrdemServicosPage from "../pages/OrdemServicosPage";
import ServicosPage from "../pages/ServicosPage";
import GruposServicosPage from "../pages/GruposServicosPage";
import CheckListOSPage from "../pages/CheckListOSPage";

import NotasFiscaisEmissaoPage from "../pages/NotasFiscaisEmissaoPage";

import OrdemServicoServicosPage from "../pages/OrdemServicoServicosPage";
import OrdemServicoAvulsosPage from "../pages/OrdemServicoAvulsosPage";

import TitulosPage from "../pages/TitulosPage";
import ReparcelamentoPage from "../pages/ReparcelamentoPage";
import CaixasPage from "../pages/CaixasPage";
import FichaFinanceiraPage from "../pages/FichaFinanceiraPage";
import CtasPagarRecPage from "../pages/CtasPagarRecPage";
import BalancoFinancPage from "../pages/BalancoFinancPage";
import ComissaoVendasPage from "../pages/ComissaoVendasPage";
import ResumoCtasPage from "../pages/ResumoCtasPage";
import CondPagtosPage from "../pages/CondPagtosPage";
import TipoDocsPage from "../pages/TipoDocsPage";
import CtasCorrentesPage from "../pages/CtasCorrentesPage";
import PlanoContasPage from "../pages/PlanoContasPage";

import EstoqueAtualPage from "../pages/EstoqueAtualPage";
import EtiquetasPage from "../pages/EtiquetasPage";
import FichaEstoquePage from "../pages/FichaEstoquePage";
import CarteiraClientesPage from "../pages/CarteiraClientesPage";

import UsuariosPage from "../pages/UsuariosPage";
import PermissoesPage from "../pages/PermissoesPage";
import GruposUsuariosPage from "../pages/GruposUsuariosPage";
import AlterarSenhaPage from "../pages/AlterarSenhaPage";
import EmpresasPage from "../pages/EmpresasPage";
import EmitentesPage from "../pages/EmitentesPage";
import ParametrosNFeCFOPPage from "../pages/ParametrosNFeCFOPPage";

const { Content } = Layout;

export default class ContentRoutes extends Component {
  state = {};
  render() {
    return (
      <Content className="contentRoutes">
        <div>
          <Route path="/" exact component={HomePage} />
          <Route path="/login" exact component={LoginPage} />

          <Route path="/vendaBalcao" exact component={VendaBalcaoPage} />
          <Route path="/pedidos" exact component={PedidosPage} />
          <Route path="/vendas" exact component={VendasPage} />
          <Route path="/condicional" exact component={CondicionaisPage} />
          <Route path="/inventario" exact component={InventarioPage} />
          <Route path="/pedidosProdutos" exact component={PedidosProdutosPage} />
          <Route path="/estornarVendas" exact component={EstornoVendasPage} />

          <Route path="/contratos" exact component={ContratosPage} />
          <Route path="/contratosFaturamento" exact component={ContratosFaturamentoPage} />

          <Route path="/compras" exact component={ComprasPage} />
          <Route path="/comprasProdutos" exact component={ComprasProdutosPage} />

          <Route path="/gruposPessoas" exact component={GruposPessoasPage} />
          <Route path="/clientes" exact component={PessoasPage} />
          <Route path="/produtos" exact component={ProdutosPage} />
          <Route path="/gruposProdutos" exact component={GruposProdutosPage} />
          <Route path="/marcas" exact component={MarcasPage} />
          <Route path="/medidas" exact component={MedidasPage} />
          <Route path="/produtosTamanho" exact component={ProdutoTamanhoPage} />
          <Route path="/produtosCor" exact component={ProdutoCorPage} />

          <Route path="/orcamentos" exact component={OrcamentosPage} />
          <Route path="/ordemServico" exact component={OrdemServicosPage} />
          <Route path="/servicos" exact component={ServicosPage} />
          <Route path="/gruposServicos" exact component={GruposServicosPage} />
          <Route path="/checklistos" exact component={CheckListOSPage} />
          <Route path="/osServicos" exact component={OrdemServicoServicosPage} />
          <Route path="/osAvulsos" exact component={OrdemServicoAvulsosPage} />

          <Route path="/emissaonf" exact component={NotasFiscaisEmissaoPage} />

          <Route path="/titulos" exact component={TitulosPage} />
          <Route path="/reparcelamento" exact component={ReparcelamentoPage} />
          <Route path="/caixas" exact component={CaixasPage} />
          <Route path="/fichaFinanc" exact component={FichaFinanceiraPage} />
          <Route path="/ctaspagarrec" exact component={CtasPagarRecPage} />
          <Route path="/balancoFinanc" exact component={BalancoFinancPage} />
          <Route path="/comissaoVendas" exact component={ComissaoVendasPage} />
          <Route path="/resumoCtas" exact component={ResumoCtasPage} />
          <Route path="/condPagtos" exact component={CondPagtosPage} />
          <Route path="/tipoDocs" exact component={TipoDocsPage} />
          <Route path="/ctaCorrentes" exact component={CtasCorrentesPage} />
          <Route path="/planoContas" exact component={PlanoContasPage} />

          <Route path="/estoqueAtual" exact component={EstoqueAtualPage} />
          <Route path="/etiquetas" exact component={EtiquetasPage} />
          <Route path="/fichaEstoque" exact component={FichaEstoquePage} />
          <Route path="/carteiraClientes" exact component={CarteiraClientesPage} />

          <Route path="/agenda" exact component={AgendaPage} />
          <Route path="/tiposAgendas" exact component={TipoAgendasPage} />
          <Route path="/configuracoes" exact component={ConfiguracoesPage} />
          <Route path="/usuarios" exact component={UsuariosPage} />
          <Route path="/permissoes" exact component={PermissoesPage} />
          <Route path="/gruposUsuarios" exact component={GruposUsuariosPage} />
          <Route path="/empresas" exact component={EmpresasPage} />
          <Route path="/emitentes" exact component={EmitentesPage} />
          <Route path="/parametrosNFeCFOP" exact component={ParametrosNFeCFOPPage} />
          <Route path="/tributacao" exact component={ConfiguracoesPage} />
          <Route path="/alterarSenha" exact component={AlterarSenhaPage} />
          <Route path="/ajuda" exact component={AjudasPage} />
          <Route path="/sobre" exact component={SobrePage} />
        </div>
      </Content>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/ContentRoutes.js